import { IwocaLogo } from '@iwoca/orion';
import clsx from 'clsx';
import { useAmplitude } from 'hooks/useAmplitude';
import { Link } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './Logo.module.css';

type TProps = {
  iconOnly?: boolean;
};

export const Logo = ({ iconOnly = false }: TProps) => {
  const { trackEvent } = useAmplitude();

  return (
    <Link
      to={PATH_NAMES.home()}
      onClick={() => {
        trackEvent(AMPLITUDE_EVENTS.internalLinkClicked, {
          'CTA destination': 'Portal',
          'CTA text': 'Iwoca logo',
          'CTA URL': PATH_NAMES.home(),
        });
      }}
      className={styles.logoLink}
      data-testid="iwoca-logo"
    >
      <IwocaLogo
        iconOnly={iconOnly}
        className={clsx(styles.logo, { [styles['iconOnly']]: iconOnly })}
      />
    </Link>
  );
};
